import { makeStyles, Tooltip } from "@material-ui/core";
import { Done, HourglassEmpty } from "@material-ui/icons";
import React from "react";
import {
  CancelAndReAnalysisButton,
  CircularProgressWithLabel,
} from "src/components/pages/projectDetails/detailsTable";
import { userHasPermission } from "src/components/utils";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import CancelOutlinedIcon from "@material-ui/icons/CancelOutlined";
import ErrorOutlineTwoToneIcon from "@material-ui/icons/ErrorOutlineTwoTone";
const useStyles = makeStyles((theme) => ({
  done: { color: theme.palette.success.main },
  error: { color: theme.palette.error.main },
  cancelled: { color: "#888888" },
  // TODO: always 360 rotate object
}));

function ProjectTableRowCell({ userObj, data, name, type, appConf }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const entitesNames = {
    kit: "kits",
    pipeline_class: "pipeline_classes",
    project_type: "project_types",
    sequencer: "sequencers",
  };
  switch (type) {
    case "string":
      return (
        <>
          {name === "kit"
            ? data.pipeline_class === "duo"
              ? ""
              : appConf.entities[entitesNames[name]][data[name]]?.label
            : appConf.entities[entitesNames[name]]
            ? name !== "pipeline_class"
              ? appConf.entities[entitesNames[name]][data[name]]
              : appConf.entities[entitesNames[name]][data["project_type"]][
                  data[name]
                ]
            : data[name]}
        </>
      );
    case "date":
      return format(new Date(data[name]), "dd/MM/yyyy HH:mm");
    case "action":
      return data.status === "completed" || data.status === "failed"
        ? userHasPermission(userObj.activePermissions, "create_project") && (
            <>
              <CancelAndReAnalysisButton
                projectId={data.id}
                projectData={data}
                sampleData={data.samples}
                type="project"
                buttonType="re"
              />
            </>
          )
        : data.status === "pending" &&
            userHasPermission(userObj.activePermissions, "create_project") && (
              <CancelAndReAnalysisButton
                projectId={data.id}
                projectData={data}
                sampleData={data.samples}
                type="project"
                buttonType="cancel"
              />
            );
    case "progress":
      return (
        <div
          style={{
            display: "flex",
            padding: "10px",
          }}
        >
          {data[name] === "completed" && (
            <Tooltip title={t(data[name]) ?? "completed"}>
              <Done color="action" className={classes.done} />
            </Tooltip>
          )}
          {data[name] === "analysing" && (
            <Tooltip title={t(data[name]) ?? "analysing"}>
              <CircularProgressWithLabel value={data.progress} />
            </Tooltip>
          )}
          {data[name] === "failed" && (
            <Tooltip title={t(data[name] ?? "failed")}>
              <ErrorOutlineTwoToneIcon
                color="action"
                className={classes.error}
              />
            </Tooltip>
          )}
          {data[name] === "cancelled" && (
            <Tooltip title={t(data[name] ?? "cancelled")}>
              <CancelOutlinedIcon
                color="action"
                className={classes.cancelled}
              />
            </Tooltip>
          )}
          {data[name] === "pending" && (
            <Tooltip title={t(data[name] ?? "pending")}>
              <HourglassEmpty
                style={{ fill: "#F7B924", width: "28px", height: "28px" }}
              />
            </Tooltip>
          )}
          {data[name] === "merge" && (
            <Tooltip title={t(data[name] ?? "merge")}>
              <HourglassEmpty
                style={{ fill: "#ffb74d", width: "32px", height: "32px" }}
              />
            </Tooltip>
          )}
        </div>
      );

    default:
      return <>{data[name]}</>;
  }
}

export default ProjectTableRowCell;
